import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Dropdown.css';
import 'react-select/dist/react-select.css';
import 'babel-polyfill';
import AsyncPaginate from 'react-select-async-paginate';

class SearchableDropDownPaginated extends Component {
  static propTypes = {
    arrowRenderer: PropTypes.func,
    className: PropTypes.string,
    clearable: PropTypes.bool,
    withCreate: PropTypes.bool,
    loadOptions: PropTypes.func.isRequired, // Return promise (Object with "ok", "options" or "errors", function receives the input from the drop down, should return array of [value, label]
    placeholder: PropTypes.string,
    value: PropTypes.any,
    pageSize: PropTypes.number,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    arrowRenderer: null,
    clearable: false,
    withCreate: false,
    pageSize: 25,
    onChange: () => {},
  };

  loadOptions = async (input, loadedOptions) => {
    let loadedOptionsCount = loadedOptions.length;
    if (this.props.withCreate) {
      loadedOptionsCount -= 1;
    }

    const page = Math.ceil(loadedOptionsCount / this.props.pageSize) + 1;
    const { options, hasMore } = await this.props.loadOptions(input, page);

    return {
      options,
      hasMore,
    };
  };

  render() {
    return (
      <div
        className={
          'searchable-dropdown' +
          (this.props.className !== undefined ? ' ' + this.props.className : '')
        }
      >
        <AsyncPaginate
          arrowRenderer={this.props.arrowRenderer}
          clearable={this.props.clearable}
          placeholder={this.props.placeholder}
          value={this.props.value}
          loadOptions={this.loadOptions}
          onChange={this.props.onChange}
        />
      </div>
    );
  }
}

export default SearchableDropDownPaginated;



// WEBPACK FOOTER //
// ./src/components/shared/dropdown/SearchableDropDownPaginated.js